import { atom } from "recoil";
import {
  IColumns,
  ICustomReport,
  ICustomReportDetails,
  SelectedRowsToDelete,
} from "../types";

export const addCustomReport = atom({
  key: "addCustomReport",
  default: false,
});

export const rowForEditCustomReport = atom<ICustomReportDetails | undefined>({
  key: "rowForEditCustomReport",
  default: undefined,
});

export const editCustomReport = atom({
  key: "editCustomReport",
  default: false,
});

export const selectedColumn = atom({
  key: "selectedColumn",
  default: [],
});

export const runCustomQuery = atom<IColumns>({
  key: "runCustomQuery",
  default: {
    label: "",
    value: "",
    tableColumns: "",
    condition: [],
    script: "",
    moduleName: "",
    orderBy: "",
  },
});

export const isRunCustomQuery = atom({
  key: "isRunCustomQuery",
  default: false,
});

export const isQueryClicked = atom({
  key: "isQueryClicked",
  default: false,
});

export const isSelectedModule = atom({
  key: "isSelectedModule",
  default: false,
});

export const addNewReport = atom({
  key: "addNewReport",
  default: false,
});

export const selectedRowsCustomToDelete = atom<
  SelectedRowsToDelete | undefined
>({
  key: "selectedRowsCustomToDelete",
  default: undefined,
});
